module.exports = __webpack_public_path__ + "img/img_commodity_retail@3x.fd921862.png";